// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-2ab","type":"styles_type__RyBc1","choices":"styles_choices__2qW2E"};